package com.snakesworld.game.domain

import com.snakesworld.game.engine.GameConstants
import com.snakesworld.game.network.SnakeNetworkState

/**
 * Deterministic election of the room Elder client for distributed backend maintenance
 * (stale snake pruning and pellet population density maintenance).
 */
object ElderDetermination {

    /**
     * Determines the current room Elder ID:
     * Snake with lowest timestamp/earliest join, breaking ties with lexicographically lower UID.
     */
    fun determineElderId(snakes: Collection<SnakeNetworkState>): String? {
        if (snakes.isEmpty()) return null
        return snakes.minWithOrNull(
            compareBy<SnakeNetworkState> { it.ts }
                .thenBy { it.id }
        )?.id
    }

    /**
     * Returns true if the local user is the elected room Elder.
     */
    fun isElder(localUid: String, snakes: Collection<SnakeNetworkState>): Boolean {
        if (snakes.isEmpty()) return true
        val elderId = determineElderId(snakes)
        return elderId == null || elderId == localUid
    }

    /**
     * Identifies snakes whose heartbeat timestamp has lapsed beyond the staleness threshold.
     */
    fun findStaleSnakes(
        snakes: Collection<SnakeNetworkState>,
        currentTimestamp: Long,
        thresholdMs: Long = GameConstants.HEARTBEAT_STALE_THRESHOLD_MS,
    ): List<String> {
        return snakes
            .filter { (currentTimestamp - it.ts) > thresholdMs }
            .map { it.id }
    }
}
